var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6308_21047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.06 11.25C22.06 10.47 21.99 9.72 21.86 9H11.5V13.26H17.42C17.16 14.63 16.38 15.79 15.21 16.57V19.34H18.78C20.86 17.42 22.06 14.6 22.06 11.25Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4997 21.9996C14.4697 21.9996 16.9597 21.0196 18.7797 19.3396L15.2097 16.5696C14.2297 17.2296 12.9797 17.6296 11.4997 17.6296C8.63969 17.6296 6.20969 15.6996 5.33969 13.0996H1.67969V15.9396C3.48969 19.5296 7.19969 21.9996 11.4997 21.9996Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.34 13.0903C5.12 12.4303 4.99 11.7303 4.99 11.0003C4.99 10.2703 5.12 9.57031 5.34 8.91031V6.07031H1.68C0.93 7.55031 0.5 9.22031 0.5 11.0003C0.5 12.7803 0.93 14.4503 1.68 15.9303L4.53 13.7103L5.34 13.0903Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4997 4.38C13.1197 4.38 14.5597 4.94 15.7097 6.02L18.8597 2.87C16.9497 1.09 14.4697 0 11.4997 0C7.19969 0 3.48969 2.47 1.67969 6.07L5.33969 8.91C6.20969 6.31 8.63969 4.38 11.4997 4.38Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6308_21047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.122c2f2324e0039306983fb15a3e0253.svg";
export { ForwardRef as ReactComponent };